export enum EStationsLocale {
  singleNominative = 'станция',
  pluralNominative = 'станции',
  pluralGenitive = 'станций',
}

/**
 * Формирует слово "станции" в нужном склонении.
 */
export function getStationsLocale(count: number): string {
  const lastNumber = Number(count.toString().slice(-1));

  switch (true) {
    // это условие всегда должно быть первым, так как 11, 12, 13, 14
    // исключение из правил
    case (count >= 11 && count <= 14):
      return EStationsLocale.pluralGenitive;
    case (lastNumber === 1):
      return EStationsLocale.singleNominative;
    case ([2, 3, 4].includes(lastNumber)):
      return EStationsLocale.pluralNominative;
    case ([5, 6, 7, 8, 9, 0].includes(lastNumber)):
      return EStationsLocale.pluralGenitive;
    default:
      return EStationsLocale.pluralGenitive;
  }
}
